var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHconnectLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 176 30",
    style: {
      enableBackground: "new 0 0 176 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#1AC463;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.000000, -77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(79.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HConnect-logo-inverse-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,6.3c-1.7-1-3.6-1.5-5.6-1.5C39.1,4.8,35,9.3,35,15.4C35,21.8,39.6,26,45.2,26c1.9,0,4.5-0.5,5.9-1.3 l0.2,3.8c-2.1,0.9-4.6,1-6.2,1c-8.6,0-14.3-5.5-14.3-14.2c0-8.4,6.1-13.9,14.3-13.9c2.1,0,4.2,0.3,6.1,1.2L51,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.5,8.7c6,0,10.1,4.4,10.1,10.4c0,5.7-4.1,10.4-10.1,10.4c-6,0-10.1-4.7-10.1-10.4 C54.3,13.1,58.4,8.7,64.5,8.7z M64.5,26.5c4.3,0,6.2-3.9,6.2-7.4c0-3.8-2.3-7.4-6.2-7.4c-3.9,0-6.2,3.7-6.2,7.4 C58.2,22.6,60.1,26.5,64.5,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,9.2H83v3.1H83c1.1-2.3,3.7-3.6,6.5-3.6c5.1,0,7.4,3.2,7.4,8.5V29h-3.7V18.7c0-4.6-1-6.9-4.2-7.1 c-4.2,0-6,3.3-6,8.2V29h-3.7V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.2,9.2h3.5v3.1h0.1c1.1-2.3,3.7-3.6,6.5-3.6c5.1,0,7.4,3.2,7.4,8.5V29h-3.7V18.7c0-4.6-1-6.9-4.2-7.1 c-4.2,0-6,3.3-6,8.2V29h-3.7V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.1,28.2c-1.4,0.5-3,1.3-6.3,1.3c-7,0-10.3-4.3-10.3-10.7c0-5.9,3.7-10,9.3-10c6.6,0,8.7,4.8,8.7,11.2 h-14.2c0,3.9,3.1,6.6,6.5,6.6c2.4,0,5.2-1.2,6.1-2V28.2z M139.8,17.2c0-3-1.8-5.5-4.9-5.5c-3.6,0-5.1,3-5.3,5.5H139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.1,12.5c-1.4-0.6-2.8-0.9-4-0.9c-4.1,0-6.4,3.7-6.4,7.4c0,3.5,1.9,7.4,6.6,7.4c1.2,0,2.8-0.4,3.9-1.1 l0.3,3.3c-1.5,0.7-3.3,0.8-4.6,0.8c-6,0-10.1-4.7-10.1-10.4c0-6,4-10.4,10.1-10.4c1.5,0,3.4,0.3,4.4,0.8L161.1,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.3,12.1h-5.2V23c0,2.3,1.4,3.5,3.1,3.5c1.1,0,1.9-0.3,2.5-0.7v3.1c-0.8,0.2-1.9,0.5-3.1,0.5 c-3.8,0-6.1-1.8-6.1-5.8V12.1H163v-3h4.5V4.6l3.7-1.2v5.8h5.2V12.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1.440000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "st2",
    points: "0,7.5 7.5,7.5 7.5,0 0,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "st2",
    points: "16.9,0 16.9,11.2 0,11.2 0,28.8 7.5,28.8 7.5,17.4 16.9,17.4 16.9,28.8 24.4,28.8 24.4,0  "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHconnectLogo);
export default __webpack_public_path__ + "static/media/hconnect_logo.19900179c45b6867ae1145dc2c3f9378.svg";
export { ForwardRef as ReactComponent };